import { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'
import { getTokenStorage } from '@/infra/settings'

export const apiGetFlows = ({ role, lang }) => {
  const headers = {
    Authorization: `Bearer ${getTokenStorage()}`
  }

  const params = new URLSearchParams()
  params.set('userType', role)
  params.set('lang', lang)
  return billmaHttpClient.get(
    `/machine/api/claim/flux${paramsToString(params)}`,
    { headers }
  )
}
